import food from './menuFood.json';
import { drinks, coffee } from './menuDrinks';
import { createMenuSearch } from './menuSearch';
export { normalizeSearch } from './menuSearch';

const label = (es, en) => ({ es, en });
const category = (id, es, en, note = null) => ({ id, name: label(es, en), note });
const noRice = label('Arroz no incluido. Añádelo en la sección Arroz.', 'Rice is not included. Add a side from the Rice section.');
export const categories = [
  category('starters', 'Aperitivos', 'Starters', label('Disponibles hasta las 15:30 al mediodía y las 22:30 por la noche.', 'Available until 15:30 at lunch and 22:30 in the evening.')),
  category('curry', 'Curry', 'Curries', noRice),
  category('vegetarian', 'Vegetarianos', 'Vegetarian', noRice),
  category('tandoori', 'Tandoori a la brasa', 'Tandoori grill', noRice),
  category('rice', 'Arroz', 'Rice'),
  category('biryani', 'Biryani', 'Biryani', label('Arroz basmati con hierbas, especias y cilantro fresco. No incluye raita ni salsa.', 'Richly spiced basmati rice with herbs and fresh coriander. Raita and sauce are not included.')),
  category('naan', 'Naan y roti', 'Naan & roti', label('Añade chiles frescos a tu naan por 1,00 € más.', 'Add fresh chillies to your naan for an extra €1.00.')),
  category('desserts', 'Postres', 'Desserts', label('Hasta las 16:00 al mediodía y las 23:00 por la noche. Pregunta por los postres veganos.', 'Until 16:00 at lunch and 23:00 in the evening. Ask about our vegan desserts.')),
  category('drinks', 'Bebidas', 'Drinks'),
  category('wines', 'Vinos indios', 'Indian wines'),
  category('coffee', 'Cafés y tés', 'Coffee & tea'),
  category('spirits', 'Licores y chupitos', 'Spirits & shots'),
];
export const proteins = food.filter(item => item.category === 'proteins').map(item => ({
  ...item,
  name: label(item.name.es.split(' / ').pop(), item.name.en.split(' / ').pop()),
}));
export const allergenNames = {
  gluten: label('Gluten', 'Gluten'), milk: label('Lácteos', 'Milk'), egg: label('Huevo', 'Egg'),
  nuts: label('Frutos secos de cáscara', 'Tree nuts'), peanuts: label('Cacahuetes', 'Peanuts'),
  mustard: label('Mostaza', 'Mustard'), sulphites: label('Sulfitos', 'Sulphites'), soy: label('Soja', 'Soya'),
  sesame: label('Sésamo', 'Sesame'), celery: label('Apio', 'Celery'), crustaceans: label('Crustáceos', 'Crustaceans'),
  lupin: label('Altramuces', 'Lupin'),
};
const foodItems = food.filter(item => item.category !== 'proteins').map(item => {
  const mapped = { ...item };
  if (item.category === 'chai') {
    mapped.category = 'coffee';
    mapped.group = label('Chai · hasta las 16:00 / 23:00', 'Chai · until 16:00 / 23:00');
  }
  if (item.category === 'lassi') {
    mapped.category = 'drinks';
    mapped.group = label('Lassis y bebidas de la India', 'Lassis & Indian drinks');
  }
  if (item.category === 'sides') {
    mapped.category = 'biryani';
    mapped.group = label('Salsas para acompañar · extra', 'Sauces on the side · extra');
  }
  if (item.category === 'biryani') {
    mapped.name = label('Biryani de ' + item.name.es.split(' / ').pop().toLowerCase(), item.name.en.split(' / ').pop() + ' Biryani');
    mapped.group = label('Elige tu biryani', 'Choose your biryani');
  }
  return mapped;
});
const retainedDrinks = [];
drinks.forEach((group, groupIndex) => {
  // Lassis are provided by the new food source, with their descriptions and current prices.
  if (groupIndex === 2) return;
  group.items.forEach((item, index) => retainedDrinks.push({
    ...item, id: 'drink-' + groupIndex + '-' + index,
    category: group.measures ? 'spirits' : 'drinks', group: group.title,
  }));
});
const retainedCoffee = coffee[0].items.map((item, index) => ({
  ...item, id: 'coffee-' + index, category: index < 4 ? 'coffee' : 'spirits',
  group: index < 4 ? label('Café e infusiones', 'Coffee & infusions') : label('Chupitos', 'Shots'),
}));
const wine = (id, name, es, en) => ({ id, category: 'wines', name: label(name, name), price: 18, description: label(es, en), allergens: ['sulphites'] });
const wines = [
  wine('wine-1', 'Sula Zinfandel Rosé', 'Rosado con notas de cítricos, arándanos y fruta madura, con dulzor y acidez equilibrados.', 'Rosé with citrus, cranberry and ripe fruit notes, balancing sweetness and acidity.'),
  wine('wine-2', 'Sula Sauvignon Blanc', 'Blanco fresco y aromático, con notas de pimiento verde y fruta tropical.', 'Fresh, aromatic white with green pepper and tropical fruit notes.'),
  wine('wine-3', 'Sula Chenin Blanc Reserve', 'Blanco aromático con notas de miel y fruta y un toque de roble.', 'Aromatic white with honey and fruit notes and a touch of oak.'),
  wine('wine-4', 'Sula Shiraz Cabernet', 'Tinto sedoso con notas terrosas, cerezas negras, pimienta y moca.', 'Silky red with earthy notes, dark cherries, pepper and mocha.'),
  wine('wine-5', 'Dindori Reserve Shiraz', 'Tinto intenso con notas especiadas, ahumadas y de frutos rojos.', 'Intense red with spicy, smoky and red fruit notes.'),
];
export const menuItems = [...foodItems, ...retainedDrinks, ...retainedCoffee, ...wines];
export const searchMenu = createMenuSearch(menuItems, categories, proteins);
export function matchesSearch(item, query) {
  return searchMenu(query).some(result => result.id === item.id);
}



// WEBPACK FOOTER //
// ./src/data/menuCatalog.js